// import React, { useState, useEffect } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet"
//  export const OlaTileLayer = () => {
//     const map = useMap();

//     useEffect(() => {
//       const olLayer = L.tileLayer(
//         "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/{z}/{x}/{y}.png?api_key=avea51wd1WTVtTOfD8DtN44JGVBGnyPTr6LvMaGK",
//         {
//           attribution: '&copy; <a href="https://www.olamaps.io/copyright">Ola Maps</a> contributors',
//         }
//       );
//       olLayer.addTo(map);

//       // Cleanup function to remove the layer if the component unmounts
//       return () => {
//         map.removeLayer(olLayer);
//       };
//     }, [map]);

//     return null;
//   };

import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

// This component adds a Google Maps tile layer to the Leaflet map
export const OlaTileLayer = () => {
  const map = useMap();

  useEffect(() => {
    // Google Maps tile layer URL for Roadmap (you can switch this URL for other Google layers)
    const googleLayer = L.tileLayer("https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
      attribution: "&copy; Google",
    });
    googleLayer.addTo(map);

    // Cleanup function to remove the layer when the component is unmounted
    return () => {
      if (map.hasLayer(googleLayer)) {
        map.removeLayer(googleLayer);
      }
    };
  }, [map]);

  return null;
};
